import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { URL, ADMIN } from "../../../../lib/lib.js";
import "./component.css";

const Component = ({componentTitle}) => {
  const navigate = useNavigate();
  const { hotelId, id } = useParams();

  const [formData, setFormData] = useState({
    name: '',
    status: true,
  });

  // Fetch user data if editing (for pre-filling the form)
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const response = await fetch(URL + ADMIN.hotel_table_view_by_id, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({tableId:id}),
          credentials: 'include'
        });
        const result = await response.json();
        const data = result.data;
        if (data) {
          setFormData({
            name: data.name ?? '',
            status: data.status ?? '',
          });
          
          // if (hotelId !== data.hotelId?._id) {
          if (String(hotelId) !== String(data.hotelId?._id)) {
            alert("IDs do not match. ");
            navigate('/admin/hotel');
          }

        }
      } catch (err) {
        console.error("Failed to fetch user details:", err);
      }
    };
  
    if (id) {
      getUserDetails();
    }

    if(!id) navigate('/admin/hotel');
    
  }, [id, hotelId, navigate]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({...prev, [name]: name === "status" ? (value === "true") : value }));
    // setFormData((prev) => ({...prev, [name]: value }));
  };

  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = { ...formData };
    if (id) dataToSend.id = id;
    
    try {
      
      const request = await fetch(URL + (id ? ADMIN.hotel_table_update : ADMIN.menu_create), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
        credentials: "include",
      });

      if (request.status === 201 || request.status === 200) {
        let response = await request.json();
        console.log(response);
        alert(response.message);
        navigate(`/admin/${hotelId}/tables`); 
        // navigate('/admin/hotel');
        // navigate(`/admin/${hotelId}/tables/${id}`);
      }
      
    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div id="adduser" className="container-fluid">
      <div className="row profile-my_flx_profile_up">
        <div className="col-xl-2 col-lg-3 col-md-2 profile-pro1 profile-admin">
          
          <Link to={`/admin/${hotelId}/tables`}>
            <button className="profile-back">
              <i className="ri-arrow-left-s-line profile-lefticon"></i>
            </button>
          </Link>
        </div>
        <div className="col-xl-8 col-lg-6 col-md-8">
          <div className="profile-my_form_signup_profile">

            <form onSubmit={handleSubmit}>
              <p className="profile-login_head">{id ? "Edit" : "Create"} {componentTitle}</p>

              <div className="mb-3 m-2 row">
                <div className="col-md-12 p-2">
                  <label className="form-label profile-user_label">Table Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Enter Name" required />
                </div>
              </div>

              {id && (
                <div className="col-md-12 p-2">
                  <label className="form-label profile-user_label">Status</label>
                  <select name="status" value={formData.status} onChange={handleChange} className="form-control" required={id} >
                    <option value="">Select Status</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
              )}

              <button type="submit" className="profile-submit_bot1">{id ? "Update" : "Create"} {componentTitle}</button>
            </form>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-2"></div>
      </div>
    </div>
  );
};

export default Component;
